import React from 'react'
import TableCell from '@material-ui/core/TableCell';
import { withStyles } from '@material-ui/core/styles';
import { useTableColumnConfig } from '../../../redux/selectors';

const CustomBodyTableCell = withStyles(theme => ({
    root: {
        padding: "0px 0px 0px 10px",
        overflow: "auto",
    },
}))(TableCell);


const BPMTableCell = (props) => {
    const {
        tableName, data, classes, fieldDescription, rowHeight
    } = props;
    const columnConfig = useTableColumnConfig(tableName, fieldDescription.id)
    const fieldVisibility = fieldDescription.getFieldVisibility(columnConfig)
    const customCellStyle = props.customCellStyle ? props.customCellStyle : {}
    const rowFontWeight = fieldDescription.rowFontWeight || {}

    return (
        <>
            {fieldVisibility ?
                <CustomBodyTableCell component="td" scope="row" className={classes ? classes.tableCell : null}>
                    <div style={{ width: "100%", height: rowHeight, maxHeight: rowHeight, display: 'flex', alignItems: 'center', overflow: 'hidden', ...rowFontWeight, ...customCellStyle }}>
                        {/* Strategy call — Cell component family (DefaultComponentCreator base): createWith(value, rowData, align). Concrete: fieldDescription.componentCreator for this column */}
                        {fieldDescription.componentCreator.createWith(data[fieldDescription.id], data, fieldDescription.fieldAlign)}
                    </div>
                </CustomBodyTableCell>
            : null}
        </>
    )
}

export default BPMTableCell;
